import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Col, Row, Table, Label, Container, FormGroup, Input } from 'reactstrap';
import ReactPaginate from 'react-paginate';
import Select from 'react-select';
import _ from 'lodash'
import api from '../../api';
import FromNow from '../../components/Time/FromNow';
import './index.css';

const STATUS_FILTER = [
    { label: 'All', value: 'all' },
    { label: 'Draft', value: 'draft' },
    { label: 'Approved', value: 'approved' },
    { label: 'Waiting for approval', value: 'waiting_for_approval'},
    { label: 'Pending', value: 'pending' },
    { label: 'Rejected', value: 'rejected' },
    { label: 'Complete', value: 'complete' },
];

// The Roster component matches one of two different routes
// depending on the full pathname
export default class TableScreen extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            sites: [],
            siteCount: 0,
            pagesCount: 0,
            page: 0,
            limit: 15,
            isLoading: false,
            statusFilter: STATUS_FILTER[0],
        }
        this.searchLocation = _.debounce(this.searchLocation, 500);
    }
    
    // TODO: refactor
    UNSAFE_componentWillMount() {
        this.getCurrentUser();
    }
    componentDidMount = () => {
        
    }
    getCurrentUser() {
        api.fetchAPI({
            method: 'get',
            uri: `userme/me`,
            success: (response) => {
                console.log(response);
                if (response.result) {
                    this.setState({
                        currentUser: response.result,
                    }, () => this.getSites(0));
                } else {
                    alert('Failed to get user: ' + response.msg);
                }
            },
            error: (error) => {
              console.error(error);
            }
        });
    }
    searchLocation() {
        this.getSites();
    }
    async getSites(pageNumber=0) {
        await this.setState({ page: pageNumber });
        const { page, limit, statusFilter, currentUser, searchKeyword } = this.state;
        let siteFilterString = '(col:is_active,opr:eq,value:1)';
        if (statusFilter) {
            if (statusFilter.value != 'complete') {
                siteFilterString = siteFilterString + ',(col:is_site_dev_location,opr:eq,value:1)';
            }
            if (statusFilter.value && statusFilter.value !== 'all') {
                siteFilterString = siteFilterString + `,(col:site_dev_status,opr:eq,value:${statusFilter.value})`;
            }
        }
        if (currentUser) {
            if (currentUser.user_brand) {
                console.log(currentUser.user_brand);
                siteFilterString = siteFilterString + `,(col:brand,opr:rel_o_m,value:${currentUser.user_brand.brand_id})`;
                if (!currentUser.user_brand.can_view_other_brand_site) {
                    // siteFilterString = siteFilterString + `,(col:brand,opr:rel_o_m,value:${currentUser.user_brand.brand_id})`;
                }
            }
        }
        if (searchKeyword) {
            const encodedSearchKeyword = searchKeyword;
            const searchByFields = [
                // 'name',
                'street_name',
                // 'address'
            ];
            searchByFields.map(searchByField => {
                siteFilterString = siteFilterString + `,(col:${searchByField},opr:ct,value:'${encodedSearchKeyword}')`;
            });
        }
        api.fetchAPI({
            method: 'get',
            uri: `location/?q=(page:${page},page_size:${limit},order_columns:created_on,order_direction:desc,filters:!(${siteFilterString}))`,
            success: (response) => {
                this.setState({
                    sites: response.result,
                    siteCount: response.count,
                    pagesCount: Math.floor(response.count / limit) + 1,
                });
                this.setState({ isLoading: false });
            },
            error: (error) => {
              console.error(error);
              this.setState({ isLoading: false });
            }
        });
    }
    render() {
        const { sites, pagesCount, statusFilter, searchKeyword } = this.state;
        if (!sites) return null;
        return (
            <Container>
                <div className="page-container">
                    <Row>
                        <Col xs={12}>
                            <h1>Sites</h1>
                        </Col>
                        <Col xs={12}>
                            <Button color="success" tag={Link} to="/sites/create">Create</Button>
                        </Col>
                    </Row>
                    <Row className="site-listing__filters">
                        <Col xs={12} sm={6} md={8}>
                            <FormGroup>
                                <Label>Search</Label>
                                <Input
                                    className="form-group"
                                    placeholder="Search theo tên đường..."
                                    value={searchKeyword}
                                    onChange={(e) => this.setState({ searchKeyword: e.target.value }, this.searchLocation)}
                                />
                            </FormGroup>
                        </Col>
                        <Col xs={12} sm={6} md={4}>
                            <FormGroup>
                                <Label>Filter: Status</Label>
                                <Select
                                    options={STATUS_FILTER}
                                    value={statusFilter}
                                    onChange={(selectedOption) => this.setState({ statusFilter: selectedOption, page: 0 }, this.getSites)}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12}>
                        {pagesCount && pagesCount > 0 ?
                            <ReactPaginate
                                previousLabel={'<'}
                                nextLabel={'>'}
                                breakLabel={'...'}
                                breakClassName={'break-me'}
                                pageCount={pagesCount}
                                marginPagesDisplayed={2}
                                pageRangeDisplayed={5}
                                initialPage={0}
                                onPageChange={page => this.getSites(page.selected)}
                                containerClassName={'pagination'}
                                subContainerClassName={'pages pagination'}
                                activeClassName={'active'}
                            />
                            :
                            null
                        }
                        </Col>
                    </Row>
                    <Table className="site-listing__tables">
                        <thead>
                            <tr>
                            <th>Địa chỉ</th>
                            <th>Người tạo</th>
                            <th>Thành phố</th>
                            <th>Tạo lúc</th>
                            <th>Trạng thái</th>
                            </tr>
                        </thead>
                        <tbody>
                            {sites.map(site => 
                                <tr key={site.id}>
                                    <td>
                                        {site.brand && site.brand.brand_logo_image &&
                                            <img className="site-listing__brand-logo-img" src={site.brand.brand_logo_image} alt={site.brand} />
                                        }
                                        <Link to={`/site/${site.id}`}>
                                            {site.address ?
                                                <span>{site.address === "" ? "Chưa có địa chỉ" : site.address}</span>
                                                :
                                                <span>{site.full_address === "" ? "Chưa có địa chỉ" : site.full_address}</span>
                                            }
                                        </Link>
                                    </td>
                                    <td>{site.created_by.first_name} {site.created_by.last_name}</td>
                                    <td>{site.city && site.city.name}</td>
                                    <td><FromNow value={site.created_on} /></td>
                                    <td>
                                        <span className={`site-status-label ${site.site_dev_status}`}>{site.site_dev_status}</span>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                    <div className="site-listing__cards">
                        <Row>
                            {sites.map(site =>
                                <Col xs={12} key={site.id} className="site-listing__card">
                                    <div className="site-listing__content">
                                        <p>
                                            {site.brand && site.brand.brand_logo_image &&
                                                <img className="site-listing__brand-logo-img" src={site.brand.brand_logo_image} alt={site.brand} />
                                            }
                                            <span className={`site-status-label ${site.site_dev_status}`}>{site.site_dev_status}</span>
                                        </p>
                                        <Link to={`/site/${site.id}`} className="site-listing__card-address">
                                            {site.address ?
                                                <span>{site.address}</span>
                                                :
                                                <span>{site.full_address}</span>
                                            }
                                        </Link>
                                        <p className="site-listing__card-since">
                                            <span className="site-listing__card-creator">{site.created_by.first_name} {site.created_by.last_name}</span>
                                            <FromNow value={site.created_on} />
                                        </p>
                                    </div>
                                </Col>
                            )}
                        </Row>
                    </div>
                </div>
            </Container>
        );
    }
}
